export class Polygon {
    id: string;
    rooms: string[];
    normalized: string[];
    macro: string[];
    tari_coeff: number[];
    area: number;
    x: number;
    y: number;
    alerts: string[];
    contour: [number, number][];

    constructor() {
        this.id = null;
        this.rooms = null;
        this.normalized = null;
        this.macro = null;
        this.tari_coeff = null;
        this.area = null;
        this.x = null;
        this.y = null;
        this.alerts = null;
        this.contour = null;
    }
}